export const authenticationQueryKey = {
  base: { scope: "authentication" },
  authenticatedUserOnLegacy: () => [
    { ...authenticationQueryKey.base, id: "legacy-auth" },
  ],
  authentication: () => [{ ...authenticationQueryKey.base, id: "auth" }],
};
